import lang from "@/views/modules/Accounts/language/en";
import breadcrumbs from "@/views/modules/Accounts/MenuList.vue";

export default {
    name: "list-scheduler",
   
    components: {
        breadcrumbs,
    },
    data() {
    },
    mounted() {
    },
    methods: { },
}